// @core/api/endpoints/tenant/delete_tenant_sso_config.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/tenant';

/**
 * Delete tenant SSO configuration
 * Removes the SSO configuration for the tenant. All users will need to use standard authentication after deletion.
 */
export async function DeleteTenantSSOConfig(
  tenant_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:tenant_id/sso`;
  requestPath = requestPath.replace(':tenant_id', encodeURIComponent(tenant_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
